






















import Vue from 'vue';
import Footer from '@/components/footer/Footer.vue';
import Header from '@/components/header/Header.vue';
import { getLocations, getFooterOptions, getUserData, cancelAppointment } from '@/api';
import { verifyUserInactivity } from './util/session';
import { mapGetters } from 'vuex';
import { ConfirmationModal, EventType, GeneralSiteError, Loader, ModalType, PageNotFound, Routes, StatusCode } from './constants';
import { bus } from './main';
import { Appointment, ConfirmationModalData } from './types';

export default Vue.extend({
  name: 'App',
  components: {
    Footer,
    Header,
    SiteError: () => import('@/components/site-error/SiteError.vue'),
    PageLoader: () => import('@/components/loader/Loader.vue'),
    ViewVersionModal: () => import('@/components/modals/NotificationModal.vue'),
    CancelAppointmentModal: () => import('@/components/modals/ConfirmationModal.vue'),
    AppointmentDetailsModal: () => import('@/components/modals/AppointmentDetailsModal.vue')
  },
  data () {
    return {
      locations: {},
      footerData: {},
      error: null as any,
      loading: false,
      isVisibleDetailsModal: false,
      isVisibleViewVersion: false,
      isVisibleConfirmationModal: false,
      appointmentCancelled: false,
      appointmentId: '',
      prevScreen: '',
      modalData: {} as ConfirmationModalData,
      appointment: {} as Appointment,
      ModalType
    };
  },
  computed: {
    ...mapGetters(['signedIn', 'isLoggedInAsAdmin'])
  },
  created () {
    bus.$on(Loader.HIDE, () => {
      this.loading = false;
    });
    bus.$on(Loader.SHOW, () => {
      this.loading = true;
    });
    bus.$on(EventType.ERROR, (code: number) => {
      this.error = (code === StatusCode.ISE)
        ? GeneralSiteError()
        : code === StatusCode.BADREQUEST
          ? PageNotFound()
          : null;
    });
    bus.$on(EventType.APPOINTMENT_DETAILS, (appointmentId: string, prevScreen: string) => {
      this.showAppointmentDetails(appointmentId, prevScreen);
    });
    bus.$on(EventType.VIEW_VERSION, (code: number) => {
      this.isVisibleDetailsModal = false;
      this.isVisibleViewVersion = true;
    });
  },
  async mounted () {
    await this.fetchUserData();
    this.fetchHeaderData();
    this.fetchFooterData();
  },
  methods: {
    async userActivity () {
      if (this.signedIn && !this.isLoggedInAsAdmin) {
        await verifyUserInactivity();
      }
    },
    fetchHeaderData () {
      // getLocations().then((data) => {
      //   if (data) {
      //     this.locations = data;
      //   }
      // });
    },
    fetchFooterData () {
      getFooterOptions().then((data) => {
        if (data) {
          this.footerData = data;
        }
      });
    },
    async setUserData () {
      await this.fetchUserData();
    },
    async fetchUserData () {
      if (this.signedIn) {
        await getUserData();
      }
    },
    handleCancelAppointment (appointment: Appointment) {
      this.isVisibleDetailsModal = false;
      this.appointment = appointment;
      if (!this.isLoggedInAsAdmin) {
        this.showConfirmationModal(ConfirmationModal.CancelAppointment)
      } else {
        this.isVisibleViewVersion = true;
      }
    },
    async removeAppointment () {
      this.isVisibleConfirmationModal = false;
      this.loading = true;
      await cancelAppointment(this.appointment);
      bus.$emit(EventType.APPOINTMENT_CANCELLED, this.appointment.appointmentId);
      this.loading = false;
      this.appointmentCancelled = true;
      this.showConfirmationModal(ConfirmationModal.AppointmentCanceled);
    },
    showConfirmationModal (modalData: ConfirmationModalData) {
      this.isVisibleConfirmationModal = true;
      this.modalData = modalData;
    },
    async closeConfirmationModal () {
      this.modalData = {} as ConfirmationModalData;
      this.isVisibleConfirmationModal = false;
      this.appointmentCancelled = false;
    },
    showAppointmentDetails (appointmentId: string, prevScreen = Routes.DASHBOARD as string) {
      this.isVisibleDetailsModal = true;
      this.appointmentId = appointmentId;
      this.prevScreen = prevScreen;
    }
  }
});
